import axios from "axios";
import Config from "src/config";

const v2_actionCredenciais = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.url_prod}/api/v2/${clienteId}/credenciais${querys ? querys : ''}`
    });
};

export default v2_actionCredenciais;
